import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("button7", component(opts));
  editor.BlockManager.add("button7", block(opts));
};